"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var bs_1 = require("react-icons/bs");
var ri_1 = require("react-icons/ri");
exports.icons = {
    plus: (0, jsx_runtime_1.jsx)(bs_1.BsPlus, {}),
    edit: (0, jsx_runtime_1.jsx)(bs_1.BsPen, {}),
    copy: (0, jsx_runtime_1.jsx)(bs_1.BsCopy, {}),
    close: (0, jsx_runtime_1.jsx)(bs_1.BsX, {}),
    exit: (0, jsx_runtime_1.jsx)(bs_1.BsArrowLeft, {}),
    delete: (0, jsx_runtime_1.jsx)(ri_1.RiDeleteBin5Line, {}),
    profile: (0, jsx_runtime_1.jsx)(bs_1.BsPersonCircle, {}),
    down: (0, jsx_runtime_1.jsx)(bs_1.BsArrowDown, {}),
    up: (0, jsx_runtime_1.jsx)(bs_1.BsArrowUp, {}),
};
